interface ApiConfigProps {
    cache_expiration_milliseconds: number;
}

export const API_CONFIG: ApiConfigProps = {
    cache_expiration_milliseconds: 10 * 60 * 1000 // 10 Minutes
};